import GenericRequest, { METHOD_PUT } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class NotificationResolveTask extends GenericRequest {

    _request; // NotificationResolveRequest

    constructor(request) {
        super(METHOD_PUT, ApiEndpoints.NOTIFICATIONS_MARK_RESOLVED);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/list/notification-resolve/NotificationResolveTask.js